"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moment = require('moment-business-days');

var uniq = require('lodash/uniq');

var flatten = require('lodash/flatten');

var camelCase = require('lodash/camelCase');

var InvitationSuite = require('../../products/invitation_suites/interface');

var ThankYouCards = require('../../products/prewedding_stationery/ThankYouCards');

var LetterpressSaveTheDates = require('../../products/prewedding_stationery/LetterpressSaveTheDates');

var SaveTheDates = require('../../products/prewedding_stationery/SaveTheDates');

var WaxSeals = require('../../products/components/WaxSeal');

var VellumJackets = require('../../products/components/VellumJacket');

var SilkRibbon = require('../../products/components/RibbonSpool');

var EnvelopeLiner = require('../../products/components/EnvelopeLiner');

var EuroFlapEnvelopeLiner = require('../../products/components/EuroFlapEnvelopeLiner');

var resolutions = ['daily', 'weekly', 'monthly'];
var date_formats = ['YYYYMMDD', 'GGGGWW', 'YYYYMM'];

function runAnalysis(orders) {
  var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'monthly';

  if (!resolutions.includes(resolution)) {
    throw new Error('Type must be one of [' + resolutions.join(', ') + ']');
  }

  var data = {};
  var date_format = date_formats[resolutions.indexOf(resolution)];
  var types = [InvitationSuite, ThankYouCards, LetterpressSaveTheDates, SaveTheDates];

  function containsSuite(order) {
    return order.products.some(function (product) {
      return types.some(function (Proto) {
        return Object.prototype.isPrototypeOf.call(Proto.prototype, product);
      });
    });
  }

  orders.forEach(function (order) {
    if (order.status === 'shipped' && order.order_date) {
      if (containsSuite(order)) {
        if (order.order_type === 'order' && !order.reprint_reason) {
          var order_month = moment(order.order_date).format(date_format);

          if (!data[order_month]) {
            data[order_month] = {};
          }

          order.products.filter(function (product) {
            return !product.type.match(/reprint/i);
          }).forEach(function (product) {
            var type = camelCase(product.type);
            var subtotal = product.subtotal;
            var acc_ribbon = 0;
            var belly_bands = 0;
            var response_cards = 0;
            var small_enclosures = 0;
            var large_enclosures = 0;
            var guest_addressing = 0;
            var return_addressing = 0;
            var guest_and_return_addressing = 0;
            var none = 1;
            var double_envelopes = 0;
            var name_printing = 0;
            var custom_postage = 0;
            var vellum_jackets = 0;
            var wax_seals = 0;
            var response_return_addressing = 0;

            function analyzeEnvelopes(component) {
              if (component.guest_addressing && component.return_addressing) {
                guest_and_return_addressing = 1;
                none = 0;
              } else if (component.guest_addressing) {
                guest_addressing = 1;
                none = 0;
              } else if (component.return_addressing) {
                return_addressing = 1;
                none = 0;
              }

              if (component.double_envelopes) {
                double_envelopes = 1;
              }

              if (component.name_printing) {
                name_printing = 1;
              }

              if (component.custom_postage) {
                custom_postage = 1;
              }
            }

            if (Object.prototype.isPrototypeOf.call(InvitationSuite.prototype, product)) {
              product.all().filter(function (component) {
                return component.quantity;
              }).forEach(function (component) {
                if (component.acc_ribbon && component.acc_ribbon !== 'None') {
                  acc_ribbon = 1;
                }

                if (component.type.match(/wrapper/i)) {
                  belly_bands = 1;
                }

                if (component.type.match(/ResponseCard$/)) {
                  response_cards = 1;
                }

                if (component.type.match(/LargeEnclosure$/)) {
                  large_enclosures = 1;
                }

                if (component.type.match(/SmallEnclosure$/)) {
                  small_enclosures = 1;
                }

                if (Object.prototype.isPrototypeOf.call(WaxSeals.prototype, component)) {
                  wax_seals = 1;
                }

                if (Object.prototype.isPrototypeOf.call(VellumJackets.prototype, component)) {
                  vellum_jackets = 1;
                }
              });
              product.invitationEnvelopes.all().filter(function (component) {
                return component.quantity;
              }).forEach(analyzeEnvelopes);
              product.responseCardEnvelopes.all().filter(function (component) {
                return component.quantity;
              }).forEach(function (component) {
                if (component.return_addressing) {
                  response_return_addressing = 1;
                }
              });
            } else if (Object.prototype.isPrototypeOf.call(ThankYouCards.prototype, product)) {
              product.thankYouCardEnvelopes.all().filter(function (component) {
                return component.quantity;
              }).forEach(analyzeEnvelopes);
            } else if (Object.prototype.isPrototypeOf.call(LetterpressSaveTheDates.prototype, product) || Object.prototype.isPrototypeOf.call(SaveTheDates.prototype, product)) {
              product.saveTheDateEnvelopes.all().filter(function (component) {
                return component.quantity;
              }).forEach(analyzeEnvelopes);
            } else if (Object.prototype.isPrototypeOf.call(WaxSeals.prototype, product)) {
              wax_seals = 1;
            } else if (Object.prototype.isPrototypeOf.call(VellumJackets.prototype, product)) {
              vellum_jackets = 1;
            } else if (Object.prototype.isPrototypeOf.call(SilkRibbon.prototype, product)) {
              acc_ribbon = 1;
            } else {
              return;
            }

            var datum = {
              subtotal: subtotal,
              guest_addressing: guest_addressing,
              return_addressing: return_addressing,
              guest_and_return_addressing: guest_and_return_addressing,
              none: none,
              acc_ribbon: acc_ribbon,
              response_return_addressing: response_return_addressing,
              double_envelopes: double_envelopes,
              name_printing: name_printing,
              custom_postage: custom_postage,
              belly_bands: belly_bands,
              response_cards: response_cards,
              small_enclosures: small_enclosures,
              large_enclosures: large_enclosures,
              wax_seals: wax_seals,
              vellum_jackets: vellum_jackets
            };

            if (!data[order_month][type]) {
              data[order_month][type] = [datum];
            } else {
              data[order_month][type].push(datum);
            }
          });
        }
      }
    }
  });
  var suites = ['classicWeddingInvitations', 'vellumWeddingInvitations', 'ribbonWeddingInvitations', 'floralWeddingInvitations', 'letterpressWeddingInvitations', 'thankYouCards', 'saveTheDates', 'letterpressSaveTheDates'];
  var suite_analysis = {
    classicWeddingInvitations: {},
    vellumWeddingInvitations: {},
    ribbonWeddingInvitations: {},
    floralWeddingInvitations: {},
    letterpressWeddingInvitations: {},
    thankYouCards: {},
    saveTheDates: {},
    letterpressSaveTheDates: {}
  };
  suites.forEach(function (key) {
    Object.keys(data).forEach(function (month) {
      var products = data[month][key] || [];
      var fields = ['subtotal', 'guest_addressing', 'return_addressing', 'guest_and_return_addressing', 'none', 'response_return_addressing', 'response_cards', 'small_enclosures', 'large_enclosures', 'acc_ribbon', 'name_printing', 'double_envelopes', 'custom_postage', 'belly_bands', 'wax_seals', 'vellum_jackets'];
      var count = products.length;
      var datum = {
        count: count
      };
      fields.forEach(function (field) {
        var collection = products.map(function (product) {
          return product[field];
        });
        var sum = Math.round(collection.reduce(function (p, v) {
          return p + v;
        }, 0));
        datum[field] = sum;
      });
      suite_analysis[key][month] = datum;
    });
  });
  var accent_ribbon_colors = {};
  var wax_seal_styles = {};
  var design_names = {};
  var liner_patterns = {};
  var liner_colors = {};
  var liner_pattern_color_pairs = {};
  var ink_colors = {};
  var paper_types = {};
  Object.values(orders).forEach(function (order) {
    if (order.status === 'shipped' && order.order_date) {
      var order_month = moment(order.order_date).format(date_format);

      if (!paper_types[order_month]) {
        paper_types[order_month] = {};
      }

      if (!design_names[order_month]) {
        design_names[order_month] = {};
      }

      if (!ink_colors[order_month]) {
        ink_colors[order_month] = {};
      }

      uniq(order.products.map(function (_ref) {
        var paper_type = _ref.paper_type;
        return paper_type;
      }).filter(function (a) {
        return a;
      })).forEach(function (paper_type) {
        if (paper_types[order_month][paper_type]) {
          paper_types[order_month][paper_type] += 1;
        } else {
          paper_types[order_month][paper_type] = 1;
        }
      });
      uniq(order.products.map(function (_ref2) {
        var design_name = _ref2.design_name;
        return design_name;
      }).filter(function (a) {
        return a;
      })).forEach(function (design_name) {
        if (design_names[order_month][design_name]) {
          design_names[order_month][design_name] += 1;
        } else {
          design_names[order_month][design_name] = 1;
        }
      });
      uniq(flatten(order.products.map(function (product) {
        return product.ink_colors;
      })).filter(function (a) {
        return a;
      })).forEach(function (ink_color) {
        if (ink_colors[order_month][ink_color]) {
          ink_colors[order_month][ink_color] += 1;
        } else {
          ink_colors[order_month][ink_color] = 1;
        }
      });
      order.products.filter(function (product) {
        return !product.type.match(/reprint/i);
      }).forEach(function (product) {
        if (!accent_ribbon_colors[order_month]) {
          accent_ribbon_colors[order_month] = {};
        }

        if (!wax_seal_styles[order_month]) {
          wax_seal_styles[order_month] = {};
        }

        if (!liner_patterns[order_month]) {
          liner_patterns[order_month] = {};
        }

        if (!liner_colors[order_month]) {
          liner_colors[order_month] = {};
        }

        if (!liner_pattern_color_pairs[order_month]) {
          liner_pattern_color_pairs[order_month] = {};
        }

        product.all().filter(function (_ref3) {
          var quantity = _ref3.quantity;
          return quantity;
        }).forEach(function (component) {
          if (Object.prototype.isPrototypeOf.call(WaxSeals.prototype, component)) {
            if (wax_seal_styles[order_month][component.wax_seal_style]) {
              wax_seal_styles[order_month][component.wax_seal_style] += 1;
            } else {
              wax_seal_styles[order_month][component.wax_seal_style] = 1;
            }
          }

          if (Object.prototype.isPrototypeOf.call(SilkRibbon.prototype, component) || component.acc_ribbon) {
            var ribbon_spool_color = component.acc_ribbon || component.ribbon_spool_color;

            if (ribbon_spool_color && ribbon_spool_color.toLowerCase() !== 'none') {
              if (accent_ribbon_colors[order_month][ribbon_spool_color]) {
                accent_ribbon_colors[order_month][ribbon_spool_color] += 1;
              } else {
                accent_ribbon_colors[order_month][ribbon_spool_color] = 1;
              }
            }
          }

          if (Object.prototype.isPrototypeOf.call(EnvelopeLiner.prototype, component) || Object.prototype.isPrototypeOf.call(EuroFlapEnvelopeLiner.prototype, component)) {
            var liner_color = component.liner_color,
                liner_pattern = component.liner_pattern;

            if (liner_color && liner_color.toLowerCase() !== 'none') {
              if (liner_colors[order_month][liner_color]) {
                liner_colors[order_month][liner_color] += 1;
              } else {
                liner_colors[order_month][liner_color] = 1;
              }
            }

            if (liner_pattern) {
              if (liner_patterns[order_month][liner_pattern]) {
                liner_patterns[order_month][liner_pattern] += 1;
              } else {
                liner_patterns[order_month][liner_pattern] = 1;
              }

              if (liner_color && liner_color.toLowerCase() !== 'none') {
                var liner_pattern_color = "".concat(liner_pattern, ":").concat(liner_color);

                if (liner_pattern_color_pairs[order_month][liner_pattern_color]) {
                  liner_pattern_color_pairs[order_month][liner_pattern_color] += 1;
                } else {
                  liner_pattern_color_pairs[order_month][liner_pattern_color] = 1;
                }
              }
            }
          }
        });
      });
    }
  });

  var analysis = _objectSpread(_objectSpread({}, suite_analysis), {}, {
    accent_ribbon_colors: accent_ribbon_colors,
    wax_seal_styles: wax_seal_styles,
    design_names: design_names,
    liner_patterns: liner_patterns,
    liner_colors: liner_colors,
    liner_pattern_color_pairs: liner_pattern_color_pairs,
    ink_colors: ink_colors,
    paper_types: paper_types
  });

  return analysis;
}

module.exports = runAnalysis;